import { IntegrationCatalogEntry as IntegrationCatalogEntryDto } from "@istari/istari-client";

import { IntegrationCatalogEntry } from "../../model/integration-catalog";

export function toIntegrationCatalogEntry(entry: IntegrationCatalogEntryDto): IntegrationCatalogEntry {
  return {
    provider: entry.provider,
    label: entry.label,
    supportedStandards: entry.supportedStandards ?? [],
    oidcDefaults: entry.oidcDefaults
      ? {
          scopes: entry.oidcDefaults.scopes ?? [],
          usePkce: entry.oidcDefaults.usePkce ?? false,
          clientSecretHeader: entry.oidcDefaults.clientSecretHeader ?? "",
          sendScopeOnRefresh: entry.oidcDefaults.sendScopeOnRefresh ?? false,
          sendRedirectUriOnRefresh: entry.oidcDefaults.sendRedirectUriOnRefresh ?? false,
        }
      : null,
    oauth1Defaults: entry.oauth1Defaults
      ? {
          rootservicesPath: entry.oauth1Defaults.rootservicesPath ?? "",
          identityPath: entry.oauth1Defaults.identityPath ?? "",
          extraTokenHeaders: entry.oauth1Defaults.extraTokenHeaders ?? {},
          twoLeggedEmptyToken: entry.oauth1Defaults.twoLeggedEmptyToken ?? false,
          authChallengeHeaders: entry.oauth1Defaults.authChallengeHeaders ?? {},
        }
      : null,
  };
}
